<template>
  <v-layout
    :class="[sortedActivities.length > 3 ? 'fade-out-right' : null]"
    class="application-activities overview"
    justify-end
    row
  >
    <div class="pl-2" v-for="(activity, i) in sortedActivities" :key="`activity-${i}`">
      <v-tooltip bottom>
        <v-badge slot="activator" bottom left class="activity__badge" color="grey">
          <v-icon slot="badge" v-if="activity.type === 'Application event'" dark small>
            mdi-arrow-right-bold
          </v-icon>
          <v-icon slot="badge" v-if="activity.type === 'Application note'" dark small>
            mdi-pencil
          </v-icon>
          <v-icon slot="badge" v-if="activity.type === 'Profile view'" dark small>
            mdi-eye
          </v-icon>
          <v-avatar size="40">
            <img
              v-if="activity.initiator"
              :src="activity.initiator.avatar || '/img/missing/avatars/original.png'"
              class="activity__avatar__image grey"
            />
          </v-avatar>
        </v-badge>
        <span v-if="activity.type === 'Application event'">
          {{ activity.initiator ? activity.initiator.fullName : 'System' }} moved application
          {{ new Date(activity.createdAt) | date('d MMM,HH:mm') }} ({{
            new Date(activity.createdAt) | inWords({ addSuffix: true })
          }})
        </span>
        <span v-else-if="activity.type === 'Application note'">
          {{ activity.initiator.fullName }} made a note
          {{ new Date(activity.createdAt) | date('d MMM,HH:mm') }} ({{
            new Date(activity.createdAt) | inWords({ addSuffix: true })
          }})
        </span>
        <span v-else-if="activity.type === 'Profile view'">
          {{ activity.initiator.fullName }} viewed application
          {{ new Date(activity.createdAt) | date('d MMM,HH:mm') }} ({{
            new Date(activity.createdAt) | inWords({ addSuffix: true })
          }})
        </span>
      </v-tooltip>
    </div>
  </v-layout>
</template>

<script>
// Helper
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
  props: { application: { type: Object, required: true } },

  computed: {
    sortedActivities() {
      if (!_.get(this, 'application.activitiesOverview')) return []

      const activities = JSON.parse(JSON.stringify(this.application.activitiesOverview))
      return activities
        .filter(a => {
          if (_.get(a, 'initiator.role') === 'Candidate') return false
          if (_.get(a, 'type') === 'Feedback request') return false
          if (_.get(a, 'type') === 'Application rating') return false

          return true
        })
        .sort(({ createdAt: a }, { createdAt: b }) => {
          if (new Date(a) < new Date(b)) return 1
          if (new Date(a) > new Date(b)) return -1
          return 0
        })
        .splice(0, 4)
    },
  },
}
</script>

<style lang="scss">
.application-activities.overview {
  &.fade-out-right {
    &::after {
      content: ' ';
      position: absolute;
      top: 25%;
      height: 60px;
      width: 30px;
      border-radius: 2rem;

      background: linear-gradient(to right, transparent 0%, #424242);
    }
  }

  .activity__badge span {
    bottom: -7px;
    left: -5px;
  }

  .activity__avatar__image {
    padding: 2px;
  }
}
</style>
